var map = {
	"./AgcServices/agc1.jpg": 2877,
	"./AgcServices/agc2.jpg": 3922,
	"./AgcServices/agc3.jpg": 303,
	"./AgcServices/agc4.jpg": 3924,
	"./AgcServices/agc5.jpg": 1969,
	"./AgcServices/agc6.jpg": 2358,
	"./AgcServices/agc7.jpg": 7619,
	"./EngServices/eng1.jpg": 5345,
	"./EngServices/eng2.jpg": 8646,
	"./EngServices/eng3.jpg": 5107,
	"./EngServices/eng4.jpg": 8624,
	"./EngServices/eng5.jpg": 3405,
	"./EngServices/eng6.jpg": 9858,
	"./EngServices/eng7.jpg": 5887,
	"./EngServices/eng8.jpg": 4172,
	"./EngServices/eng9.jpg": 2217,
	"./EnvServices/env1.jpg": 9009,
	"./EnvServices/env2.jpg": 6870,
	"./EnvServices/env3.jpg": 1635,
	"./EnvServices/env4.jpg": 1472,
	"./EnvServices/env5.jpg": 3213,
	"./EnvServices/env6.jpg": 5410,
	"./EnvServices/env7.jpg": 1791,
	"./GenServices/gen1.jpg": 8021,
	"./GenServices/gen10.jpg": 6793,
	"./GenServices/gen2.jpg": 1770,
	"./GenServices/gen3.jpg": 9255,
	"./GenServices/gen4.jpg": 4412,
	"./GenServices/gen5.jpg": 2457,
	"./GenServices/gen6.jpg": 9374,
	"./GenServices/gen7.jpg": 859,
	"./GenServices/gen8.jpg": 2512,
	"./GenServices/gen9.jpg": 3645,
	"./ManServices/man1.jpg": 4598,
	"./ManServices/man2.jpg": 6078,
	"./ManServices/man3.jpg": 2539,
	"./ManServices/man4.jpg": 9704,
	"./ManServices/man5.jpg": 6965,
	"./OilServices/oil1.jpg": 2225,
	"./OilServices/oil2.jpg": 4454,
	"./OilServices/oil3.jpg": 2979,
	"./OilServices/oil4.jpg": 1328,
	"./OilServices/oil5.jpg": 2253,
	"./OilServices/oil6.jpg": 2994,
	"./OilServices/oil7.jpg": 5663,
	"./Partners/Baghdad.jpg": 5222,
	"./Partners/MayoraltyOfBaghdad.jpg": 9965,
	"./Partners/PACT.jpg": 3891,
	"./Partners/SCDPI.jpg": 3952,
	"./Partners/Wasat.jpg": 6143,
	"./Partners/ameer.jpg": 6421,
	"./Partners/industry.jpg": 6493,
	"./Partners/oil.jpg": 3135,
	"./Partners/prinz.jpg": 8784,
	"./Partners/seko.jpg": 2045,
	"./Partners/terre.jpg": 4697,
	"./Partners/water.jpg": 7350,
	"./aboutus.jpg": 6828,
	"./ceo.jpg": 5924,
	"./hero.jpg": 7347
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7088;